"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var IntegrationTemplateHelper = /** @class */ (function () {
    function IntegrationTemplateHelper() {
        this.cachedInstances = {};
        this.ajaxProvider = (0, AjaxProvider_1.default)("/api");
    }
    IntegrationTemplateHelper.prototype.getById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this.cachedInstances[id]) {
                            resolve(_this.cachedInstances[id]);
                        }
                        else {
                            var params = { id: id };
                            _this.ajaxProvider.getOne("app-integration-templates", params)
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .then(function (response) {
                                var template = _this.hydrateExtended(response.data, _this.hydrate(response.data));
                                if (template) {
                                    _this.cachedInstances[id] = template;
                                    resolve(_this.cachedInstances[id]);
                                }
                            }).catch(function (e) {
                                {
                                    reject(e);
                                }
                            });
                        }
                    })];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationTemplateHelper.prototype.hydrate = function (data, template) {
        if (!template) {
            return {
                id: data.id,
                name: data.name,
                type: data.type,
                current_version: data.current_version,
                current_patch_version: data.current_patch_version,
                icon: data.icon,
                description: data.description,
                description_link: data.description_link,
                visible: data.visible,
                created_at: data.created_at,
                updated_at: data.updated_at,
                created_by: data.created_by,
            };
        }
        else {
            if (data.name !== undefined) {
                template.name = data.name;
            }
            if (data.type !== undefined) {
                template.type = data.type;
            }
            if (data.current_version !== undefined) {
                template.current_version = data.current_version;
            }
            if (data.current_patch_version !== undefined) {
                template.current_patch_version = data.current_patch_version;
            }
            if (data.icon !== undefined) {
                template.icon = data.icon;
            }
            if (data.description !== undefined) {
                template.description = data.description;
            }
            if (data.description_link !== undefined) {
                template.description_link = data.description_link;
            }
            if (data.visible !== undefined) {
                template.visible = data.visible;
            }
            if (data.created_at !== undefined) {
                template.created_at = data.created_at;
            }
            if (data.updated_at !== undefined) {
                template.updated_at = data.updated_at;
            }
            if (data.created_by !== undefined) {
                template.created_by = data.created_by;
            }
            return template;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationTemplateHelper.prototype.hydrateExtended = function (data, template) {
        var _this = this;
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var definition = (_a = template.definition) !== null && _a !== void 0 ? _a : {};
        definition.setup_quick_guide = data.setup_quick_guide;
        if (!definition.script) {
            definition.script = {
                version: data.script.version,
                settings: [],
                scripts: {},
                translations: data.script.translations,
            };
        }
        else {
            if (data.script.version !== undefined) {
                definition.script.version = data.script.version;
            }
            if (data.script.scripts !== undefined) {
                definition.script.scripts = data.script.scripts;
            }
            if (data.script.translations !== undefined) {
                definition.script.translations = data.script.translations;
            }
            definition.script.settings = [];
        }
        if (data.script.settings !== undefined) {
            Object.keys(data.script.settings).forEach(function (key) {
                definition.script.settings.push(q_play_core_1.Setting.createSettingFromData(key, data.script.settings[key]));
            });
            definition.script.settings.sort(function (a, b) { return a.order > b.order ? 1 : (a.order < b.order ? -1 : 0); });
        }
        Object.keys(data.script.scripts).map(function (identifier) {
            definition.script.scripts[identifier] = _this.createResourceFromData(data.script.scripts[identifier]);
        });
        template.definition = definition;
        return template;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationTemplateHelper.prototype.createResourceFromData = function (data) {
        var result = {
            id: data.id,
            identifier: data.identifier,
            name: data.name,
            schedule: data.schedule,
            settings: [],
            resources: JSON.parse(JSON.stringify(data.resources))
        };
        if (data.settings) {
            Object.keys(data.settings).forEach(function (key) {
                var setting = q_play_core_1.Setting.createSettingFromData(key, data.settings[key]);
                if (setting) {
                    result.settings.push(setting);
                }
            });
            result.settings.sort(function (a, b) { return a.order > b.order ? 1 : (a.order < b.order ? -1 : 0); });
        }
        return result;
    };
    IntegrationTemplateHelper.prototype.removeCachedById = function (id) {
        delete this.cachedInstances[id];
        return this;
    };
    return IntegrationTemplateHelper;
}());
var integrationTemplateHelper = new IntegrationTemplateHelper();
exports.default = integrationTemplateHelper;
